import {
  useUtilityRevenue,
  useDashboardSummary,
  useUtilitySetup,
} from "../../hooks";
import { KPIData } from "../../types";
import { BillingCycleCard } from "./BillingCycleCard";
import CustomerServiceCard from "./CustomerServiceCard";
import { ArrowUp, ArrowDown } from "lucide-react";
import { FieldOperationsCard } from "./FieldOperationsCard";
import { KPICard } from "./KPICard";
import MeterManagementCard from "./MeterManagementCard";
import { ProgressBar } from "./ProgressBar";
import RevenueCollectionCard from "./RevenueCollectionCard";
import SetupCardGrid from "./setup.cards";
import { useCurrency } from "@shared/selectors/globalSelectors";
import { QuickStatsCard } from "@features/cx/shared/components/QuickStatsCard";

const UtilityAdminDashboard = () => {
  // const { data } = useDashboardSummary();
  const { data: setupData } = useUtilitySetup();
  const currency = useCurrency();

  // const kpiData =
  //   data?.workOrderSummary &&
  //   data?.revenueSummary &&
  //   data?.consumerRequests &&
  //   data?.billDetail
  //     ? [
  //         {
  //           title: "Monthly Revenue",
  //           count: `${currency} ${data.revenueSummary.monthlyRevenueChange}`,
  //           trend: data.workOrderSummary.completionPercentage,
  //           trendDurationDisplay: 'from last month',
  //         },
  //         {
  //           title: "Billing Cycle",
  //           count: data.billDetail.cycleCompletion.toString() + "%",
  //           trendSummary: 'Completed'
  //         },
  //         {
  //           title: "Service Requests",
  //           count: `${data.consumerRequests.totalRequests}`,
  //           trend:
  //             data.revenueSummary.totalPaymentReceived > 0
  //               ? (data.revenueSummary.totalPaymentReceived /
  //                   data.revenueSummary.totalBillAmount) *
  //                 100
  //               : 0,
  //               trendDurationDisplay: "from last month",
  //         },
  //         {
  //           title: "Work Orders",
  //           count: `${data.workOrderSummary.completed}/${data.workOrderSummary.total}`,
  //           trendSummary: "Completed",
  //         },
  //       ]
  //     : [];

  // const { data: revenue, isLoading: isRevenueLoading } = useUtilityRevenue();
  // const stats = revenue
  //   ? {
  //       todayCollection: revenue.todayCollection,
  //       todayCollectionChange: revenue.todayCollectionChange,
  //       todayCollectionIsPositive: revenue.todayCollectionIsPositive,
  //       collectionEfficiency: revenue.collectionEfficiency,
  //       efficiencyChange: revenue.monthlyRevenueChange,
  //       efficiencyIsPositive: revenue.monthlyRevenueIsPositive,
  //     }
  //   : null;

  // const outstandingPayments = revenue?.agingBuckets
  //   ? [
  //       {
  //         name: "0–30 days",
  //         amount: revenue.agingBuckets.days_0_30,
  //         color: "#22c55e",
  //       },
  //       {
  //         name: "30–60 days",
  //         amount: revenue.agingBuckets.days30To60,
  //         color: "#3b82f6",
  //       },
  //       {
  //         name: "60–90 days",
  //         amount: revenue.agingBuckets.days60To90,
  //         color: "#facc15",
  //       },
  //       {
  //         name: "90+ days",
  //         amount: revenue.agingBuckets.days90Plus,
  //         color: "#ef4444",
  //       },
  //     ]
  //   : [];
  // const highPriorityRequests = [
  //   {
  //     id: "1",
  //     priority: "critical" as const,
  //     title: "No Water Supply",
  //     description:
  //       "Customer reports complete loss of water supply since this morning",
  //     timestamp: "30 min ago",
  //     hasAction: true,
  //   },
  //   {
  //     id: "2",
  //     priority: "high" as const,
  //     title: "Pending Inspection",
  //     description: "",
  //     timestamp: "1 hour ago",
  //   },
  // ];

  // const billingStats = {
  //   generated: 52430,
  //   delivered: 49856,
  //   paid: 36701,
  // };

  return (
    <div className="">
      {/* Header */}
      <div className="flex flex-col gap-5">
        <div>
          <p className="page-title">Utility Admin Dashboard</p>
          <p className="page-subtitle">
            Manage water, electricity, and gas utilities
          </p>
        </div>
        <div className="bg-white rounded-lg p-4 shadow-sm border">
          <ProgressBar
            progress={setupData?.overallPercentage || 0}
            showLabel
            label="Utility Setup Progress"
          />
        </div>

        {/* KPI Cards */}
        {/* <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
            {kpiData.map((kpi, index) => (
              <QuickStatsCard {...kpi} />
            ))}
          </div> */}
      </div>

      {/* Charts Section */}
      {/* First Row: 3-column layout for first 3 cards */}
      {/* <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6 mb-8">
          <RevenueCollectionCard />
          <CustomerServiceCard />
          <MeterManagementCard />
        </div> */}

      {/* Second Row: 2-column layout for remaining cards */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8">
        {/* Billing Cycle Progress */}
        {/* {data?.billDetail && (
            <BillingCycleCard
              title="Billing Cycle Progress"
              percentage={data.billDetail.cycleCompletion}
              pieData={[
                {
                  name: "completed",
                  value: data.billDetail.cycleCompletion,
                  color: "#3B82F6",
                },
                {
                  name: "remaining",
                  value: 100 - data.billDetail.cycleCompletion,
                  color: "#E5E7EB",
                },
              ]}
              stats={{
                generated: data.billDetail.totalGeneratedBills,
                delivered: data.billDetail.deliveredBills,
                paid: data.billDetail.paid,
              }}
              actionLabel="View Details"
            />
          )} */}

        {/* Field Operations */}
        {/* {data?.workOrderSummary && (
            <FieldOperationsCard
              stats={{
                completed: data.workOrderSummary.completed,
                in_progress: data.workOrderSummary.inProgress,
                overdue: data.workOrderSummary.overdue,
                total: data.workOrderSummary.total,
              }}
            />
          )} */}
      </div>

      {/* Setup Cards */}
      <SetupCardGrid />
    </div>
  );
};

export default UtilityAdminDashboard;
